import React, { useCallback, useEffect, useState, useRef } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col, Table } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import Pagination from "../../../../../components/ui/Pagination";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import RadioButton from "../../../../../components/ui/RadioButton";
import DropDown from "../../../../../components/ui/DropDown";
import Button from "../../../../../components/ui/Button";

// import AllLinks from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/BrandInsight/BacklinkAudit/AllLinks";
// import Malicious from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/BrandInsight/BacklinkAudit/Malicious";

import { filterIcon } from "../../../../../utils/icons";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getScanInfoStats, resetScanInfoStats, getBacklinkList, resetBacklinkList } from "../../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../../apiEndpoints";
import { formatNumber } from "../../../../../utils/util";

const suspiciousOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const urlTypeOption = [ 
    {
        label: "All",
        value: "all"
    },   
    {
        label: "Malicious",
        value: "malicious"
    },
    {
        label: "Suspicious",
        value: "suspicious"
    },
    {
        label: "Internal",
        value: "internal"
    },
    {
        label: "External",
        value: "external"
    }
]

const categoryOption = [
    {
        label: "All",
        value: "all"
    },
    {
        label: "gambling",
        value: "gambling"
    },
    {
        label: "Casino",
        value: "casino"
    },
    {
        label: "Adult",
        value: "adult"
    },
    {
        label: "Betting",
        value: "betting"
    },
    {
        label: "Pharma",
        value: "pharma"
    },
]


const BacklinkAudit = () => {

    const backlinkStatsResponse = useSelector((state) => state.scanInfo?.scanInfoStats);
    const backlinkAuditListResponse = useSelector((state) => state.scanInfo?.backlinkAuditList);

    const dispatch = useDispatch();
    const filterWrapperRef = useRef(null);

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    // const [activeTab, setActiveTab] = useState("dashboard");
    const [statsLoading, setStatsLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);    
    const [backlinkStats, setBacklinkStats] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [backlinkList, setBacklinkList] = useState(null);

    const [showFilter, setShowFilter] = useState(false);
    const [selectedSuspicious, setSelectedSuspicious] = useState("");
    const [selectedUrlType, setSelectedUrlType] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const setCurrentPageandRecordSize = (page, pageSize) => {
        if (page === currentPage && pageSize === currentPageSize) return;

        if (pageSize !== currentPageSize) {
            setCurrentPage(1);
            setCurrentPageSize(pageSize);
            setContextCurrentPage(1);
            return;
        }

        setCurrentPage(page);
        setContextCurrentPage(page);
    };

    const applyFilter = () => {
        setCurrentPage(1);
        setShowFilter(false);
        setSelectedFilterValue({
            suspicious: selectedSuspicious,
            urlType: selectedUrlType,
            category: selectedCategory
        });
        setContextCurrentPage(1);
    };

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1);
        setSelectedFilterValue({});
        setSelectedSuspicious("");
        setSelectedUrlType("");
        setSelectedCategory("");
        setContextCurrentPage(1);
    };

    const fetchdashboardStats = useCallback(() => {
        setStatsLoading(true);
        const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.brandInsight.backlinkAudit.dashboardStats()}`;
        const params =
            organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all"
                ? `&organization_id=${organizationId}`
                : `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getScanInfoStats(`${baseUrl}${params}`));
    }, [dispatch, domainId, scanId, organizationId]);

    const fetchDashboardList = useCallback(() => {
        setIsLoading(true);
        setScanNotFound(false);

        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const params =
            organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all"
                ? `&organization_id=${organizationId}`
                : `&domain=${domainId}&scan_id=${scanId}`;

        const urlType =
            selectedFilterValue?.urlType && selectedFilterValue?.urlType !== "all"
                ? `&url_type=${selectedFilterValue.urlType}`
                : "";

        const category =
            selectedFilterValue?.category && selectedFilterValue?.category !== "all"
                ? `&category=${selectedFilterValue.category}`
                : "";

        const susTld =
            selectedFilterValue?.suspicious && selectedFilterValue?.suspicious !== "all"
                ? `&suspicious_tld=${selectedFilterValue.suspicious === "yes"}`
                : "";

        dispatch(getBacklinkList(`${baseUrl}${params}${urlType}${category}${susTld}`));
    }, [dispatch, currentPage, currentPageSize, domainId, scanId, organizationId, selectedFilterValue]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if (showFilter) {
                    setShowFilter(false);
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFilter]);

     useEffect(() => {
        if (triggerStatsFetch) {
            fetchdashboardStats();
            setCurrentPage(1);
            setContextCurrentPage(1);
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setContextCurrentPage, setTriggerStatsFetch, fetchdashboardStats]);

    useEffect(() => {
        fetchDashboardList();
    }, [currentPage, currentPageSize, selectedFilterValue, domainId, scanId, organizationId, fetchDashboardList]);

    useEffect(()=>{
        if(backlinkStatsResponse !== null) {            
            setStatsLoading(false)
            setBacklinkStats(backlinkStatsResponse)
            dispatch(resetScanInfoStats())
        }
    },[backlinkStatsResponse, dispatch])

    useEffect(()=>{
        if(backlinkAuditListResponse !== null) {
            setIsLoading(false);
            setBacklinkList(backlinkAuditListResponse);
            dispatch(resetBacklinkList())
        }
    },[backlinkAuditListResponse, dispatch])

    return (
        <>
            <div className="scan-info-main-content portfolio-risk-main-content">
                <div className="bg-white-with-shadow p-4">
                    <div className="tab-details-container">
                        {statsLoading ?
                            <SkeletonLoader type={"line"} count={4} currentPage={"backlink"} />
                        :
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="dashboard-container">
                                <div className="link-risk-overview-container my-3">
                                    <Row>
                                        <Col lg={4}>
                                            <p className="heading">Link Risk Overview</p>
                                            <h2 className="total-count mt-3">{formatNumber(backlinkStats?.url_type?.total)} <span>Total Links</span></h2>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="dashboard-type-container rounded p-3">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Malicious</p>
                                                    <p className="link-risk-count">{formatNumber(backlinkStats?.url_type?.malicious)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-4">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Suspicious</p>
                                                    <p className="link-risk-count">{formatNumber(backlinkStats?.url_type?.suspicious)}</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="dashboard-type-container rounded p-3">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Internal</p>
                                                    <p className="link-risk-count">{formatNumber(backlinkStats?.url_type?.internal)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-4">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">External</p>
                                                    <p className="link-risk-count">{formatNumber(backlinkStats?.url_type?.external)}</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </motion.div>}
                    </div>
                </div>
                <div className="mt-4">
                    <div className="bg-white-with-shadow p-4">
                        {
                            isLoading ? 
                                <SkeletonLoader type={"line"} count={7} currentPage={"backlink"} />
                            :
                            <div className="threats-table">
                                <div className="table-heading d-flex align-items-center gap-3 mb-3">
                                    <h2 className="heading">Backlink</h2>                                        
                                    <div className="position-relative">                                        
                                        <span className="filter-icon cursor-pointer" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                            <h6>Type</h6>
                                            <DropDown 
                                                placeHolder={"Url Type"}
                                                options={urlTypeOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedUrlType(data.value)}}
                                                defaultSelectedValue={selectedUrlType}
                                            />
                                            <h6 className="mt-4">Category</h6>
                                            <DropDown 
                                                placeHolder={"Category"}
                                                options={categoryOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedCategory(data.value)}}
                                                defaultSelectedValue={selectedCategory}
                                            />
                                            <h6 className="mt-4">Suspecious Tld</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    suspiciousOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedSuspicious(value)}} key={`new-${index}`} isChecked={data.value === selectedSuspicious} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="filter-apply-btn mt-3">
                                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={selectedSuspicious === "" && selectedUrlType === "" && selectedCategory === ""} buttonClicked={()=>{applyFilter()}}/>
                                            </div>
                                        </div>}
                                    </div>
                                    {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                </div>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Domain</th>
                                            <th className="url">Url</th>
                                            <th>Type</th>
                                            <th>Category</th>
                                            <th>Name</th>
                                            <th>Risk</th>
                                            <th>Source</th>
                                            <th>tld</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            backlinkList?.results?.length > 0 && 
                                            backlinkList?.results?.map((data, index)=>{
                                                return (
                                                    <motion.tr
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <td>{data?.domain}</td>
                                                        <td><p className="url">{data?.url}</p></td>
                                                        <td>
                                                            {data?.url_type === "malicious" && <p className="risk-status critical">{data?.url_type}</p>}
                                                            {data?.url_type === "suspicious" && <p className="risk-status high">{data?.url_type}</p>}
                                                            {data?.url_type === "internal" || data?.url_type === "external" ? <p className="risk-status internal">{data?.url_type}</p> : ""}
                                                        </td>
                                                        <td>
                                                            <p className="table-status category">{data?.category}</p>
                                                        </td>
                                                        <td>{data?.name}</td>
                                                        <td>
                                                            {data?.risk_level === "clean" && <p className="risk-status low">{data?.risk_level}</p>}
                                                            {data?.risk_level === "danger" && <p className="risk-status critical">{data?.risk_level}</p>}
                                                            {data?.risk_level === "warning" && <p className="risk-status high">{data?.risk_level}</p>}
                                                        </td>
                                                        <td>
                                                            <p>{data?.source}</p>
                                                        </td>
                                                        <td>
                                                            <p className={`risk-status ${data?.suspicious_tld ? 'critical' : 'medium'}`}>{data?.tld}</p>
                                                        </td>
                                                    </motion.tr>
                                                )
                                            })
                                        }
                                        {
                                            !scanNotFound && backlinkList !== "" && backlinkList?.results?.length === 0 && 
                                            <motion.tr
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4 }}
                                            >
                                                <td colSpan={8}>
                                                    <NoDataFound noDataText={"No Record Found"} />
                                                </td>
                                            </motion.tr>
                                        }                                    
                                    </tbody>
                                </Table>
                                {backlinkList !== null && backlinkList?.results?.length > 0 && <Pagination
                                    className="pagination-bar"
                                    currentPage={currentPage}
                                    pageSize={currentPageSize}
                                    totalCount={backlinkList?.meta?.total_results}
                                    onPageChange={setCurrentPageandRecordSize}
                                />}
                            </div>
                        }
                        { !isLoading && backlinkList?.status === "failed" &&
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={backlinkList?.description}/>
                            </motion.div>
                        }                            
                    </div>
                </div>
            </div>
        </>      
    )
}


export default BacklinkAudit;